import env from '@/core/config/env';

/**
 * Helper to resolve media URLs from backend
 * If the URL is relative (e.g. /uploads/...), prepends the backend base URL.
 */
export const getMediaUrl = (url?: string | null): string | undefined => {
    if (!url) return undefined;
    if (url.startsWith('http')) return url;
    
    const apiUrl = env.API_URL || 'http://localhost:8000/api';
    const baseUrl = apiUrl.endsWith('/api') ? apiUrl.slice(0, -4) : apiUrl;
    
    return `${baseUrl}${url.startsWith('/') ? '' : '/'}${url}`;
};
